/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-navigation-add': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10.625 9.375v-5h-1.25v5h-5v1.25h5v5h1.25v-5h5v-1.25z"/>'
  }
})
